import React, { useEffect, useState } from "react";
import { createNewUser, deactivateUser } from "../firebaseConfig";
import { db } from "../firebaseConfig";
import {
  collection,
  addDoc,
  updateDoc,
  getDocs,
  deleteDoc,
  doc,
  Timestamp,
  query,
  where
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import * as XLSX from "xlsx";

const AdminPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("123456");
  const [role, setRole] = useState("Kullanıcı");
  const [message, setMessage] = useState("");
  const [deactivateEmail, setDeactivateEmail] = useState("");
  const [plate, setPlate] = useState("");
  const [type, setType] = useState("");
  const [model, setModel] = useState("");
  const [facility, setFacility] = useState("");
  const [aciklama, setAciklama] = useState("");
  const [existingPlates, setExistingPlates] = useState([]);
  const [isNewPlate, setIsNewPlate] = useState(true);
  const [authEmail, setAuthEmail] = useState("");

  const [searchDate, setSearchDate] = useState("");
  const [newDate, setNewDate] = useState("");
  const [issues, setIssues] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    const auth = getAuth();
    const unsub = auth.onAuthStateChanged((user) => {
      if (user) setAuthEmail(user.email);
    });

    const fetchPlates = async () => {
      const snapshot = await getDocs(collection(db, "plates"));
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      const sorted = data.sort((a, b) => a.plate.localeCompare(b.plate, "tr"));
      setExistingPlates(sorted);
    };
    fetchPlates();

    return () => unsub();
  }, []);

  const handleCreate = async () => {
    const result = await createNewUser(email, password, role);
    setMessage(result.success ? "✅ Kullanıcı başarıyla eklendi." : "❌ Hata: " + result.error);
  };

  const handleDeactivate = async () => {
    const result = await deactivateUser(deactivateEmail);
    setMessage(result.success ? "🚫 Kullanıcı pasif yapıldı." : "❌ Hata: " + result.error);
  };

  const handleAddOrUpdatePlate = async () => {
    if (!plate) return;
    const plateFormatted = plate.toUpperCase().replace(/\s+/g, "");
    const existing = existingPlates.find((p) => p.plate === plateFormatted);

    const newData = {
      plate: plateFormatted,
      aracCinsi: type,
      model,
      tesis: facility,
      aciklama,
      active: true,
      createdBy: authEmail,
      createdTime: Timestamp.now(),
    };

    if (existing) {
      await updateDoc(doc(db, "plates", existing.id), newData);
      setMessage("✅ Plaka güncellendi.");
    } else {
      await addDoc(collection(db, "plates"), newData);
      setMessage("✅ Plaka eklendi.");
    }

    setPlate("");
    setType("");
    setModel("");
    setFacility("");
    setAciklama("");
    setIsNewPlate(true);
  };

  const handleTamamlaEksikAlanlar = async () => {
    const snapshot = await getDocs(collection(db, "plates"));
    const updates = snapshot.docs.map((docSnap) => {
      const data = docSnap.data();
      const id = docSnap.id;
      const update = {};
      if (!("aciklama" in data)) update.aciklama = "";
      if (!("active" in data)) update.active = true;
      if (!("createdBy" in data)) update.createdBy = authEmail;
      if (!("createdTime" in data)) update.createdTime = Timestamp.now();
      if (Object.keys(update).length > 0) return updateDoc(doc(db, "plates", id), update);
      return null;
    });
    await Promise.all(updates.filter(Boolean));
    alert("✅ Eksik alanlar tamamlandı.");
  };

  const handlePlateSelect = (e) => {
    const selected = e.target.value;
    if (selected === "__new__") {
      setPlate("");
      setType("");
      setModel("");
      setFacility("");
      setAciklama("");
      setIsNewPlate(true);
    } else {
      setPlate(selected);
      setIsNewPlate(false);
      const found = existingPlates.find((p) => p.plate === selected);
      if (found) {
        setType(found.aracCinsi || "");
        setModel(found.model || "");
        setFacility(found.tesis || "");
        setAciklama(found.aciklama || "");
      }
    }
  };

  const handleExportPlatesToExcel = () => {
    const data = existingPlates.map(p => ({
      Plaka: p.plate,
      "Araç Cinsi": p.aracCinsi || "",
      Model: p.model || "",
      Tesis: p.tesis || "",
      Açıklama: p.aciklama || "",
      Aktif: p.active ? "✔️" : "❌",
      Oluşturan: p.createdBy || "",
      "Oluşturma Tarihi": p.createdTime?.toDate().toLocaleString("tr-TR") || ""
    }));
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(wb, ws, "Plakalar");
    XLSX.writeFile(wb, "plaka_listesi.xlsx");
  };

  const handleDeleteAllLogins = async () => {
    const snapshot = await getDocs(collection(db, "logins"));
    const promises = snapshot.docs.map((docu) => deleteDoc(doc(db, "logins", docu.id)));
    await Promise.all(promises);
    alert("✅ Tüm login kayıtları silindi.");
  };

  const handleFindIssuesByDate = async () => {
    if (!searchDate) return;
    const snapshot = await getDocs(collection(db, "issues"));
    const selectedDay = new Date(searchDate);
    selectedDay.setHours(0, 0, 0, 0);

    const filtered = snapshot.docs.filter((d) => {
      const ts = d.data().date;
      if (!ts || !ts.toDate) return false;
      const docDate = ts.toDate();
      return docDate.toDateString() === selectedDay.toDateString();
    });

    setIssues(filtered.map(doc => ({ id: doc.id, ...doc.data() })));
    setSelectedIds(filtered.map(doc => doc.id));
  };

  const handleUpdateSelectedDates = async () => {
    if (!newDate || selectedIds.length === 0) return;
    const promises = selectedIds.map(id => updateDoc(doc(db, "issues", id), {
      date: Timestamp.fromDate(new Date(newDate))
    }));
    await Promise.all(promises);
    alert("✅ Tarihler güncellendi.");
    setSearchDate("");
    setNewDate("");
    setIssues([]);
    setSelectedIds([]);
  };

  return (
    <div style={{ padding: 20, maxWidth: 600, margin: "auto" }}>
      <h2>Yeni Kullanıcı Oluştur</h2>
      <input placeholder="E-posta" value={email} onChange={(e) => setEmail(e.target.value)} style={inputStyle} />
      <input type="password" placeholder="Şifre" value={password} onChange={(e) => setPassword(e.target.value)} style={inputStyle} />
      <select value={role} onChange={(e) => setRole(e.target.value)} style={inputStyle}>
        <option value="Yetkili">Yetkili</option>
        <option value="Kullanıcı">Kullanıcı</option>
        <option value="Oluşturucu">Oluşturucu</option>
      </select>
      <button onClick={handleCreate} style={buttonStyle}>Kullanıcı Oluştur</button>

      <h2 style={{ marginTop: 40 }}>Kullanıcıyı Pasif Yap</h2>
      <input placeholder="E-posta girin" value={deactivateEmail} onChange={(e) => setDeactivateEmail(e.target.value)} style={inputStyle} />
      <button onClick={handleDeactivate} style={buttonStyle}>Pasifleştir</button>

      <h2 style={{ marginTop: 40 }}>Plaka Ekle / Güncelle</h2>
      <select onChange={handlePlateSelect} value={isNewPlate ? "__new__" : plate} style={inputStyle}>
        <option value="__new__">Yeni Plaka Ekle</option>
        {existingPlates.map((p) => (
          <option key={p.id} value={p.plate}>{p.plate}</option>
        ))}
      </select>
      {isNewPlate && (
        <input placeholder="Yeni Plaka Girin" value={plate} onChange={(e) => setPlate(e.target.value.toUpperCase().replace(/\s+/g, ""))} style={inputStyle} />
      )}
      <input placeholder="Araç Cinsi" value={type} onChange={(e) => setType(e.target.value)} style={inputStyle} />
      <input placeholder="Model" value={model} onChange={(e) => setModel(e.target.value)} style={inputStyle} />
      <input placeholder="Tesis" value={facility} onChange={(e) => setFacility(e.target.value)} style={inputStyle} />
      <input placeholder="Açıklama" value={aciklama} onChange={(e) => setAciklama(e.target.value)} style={inputStyle} />
      <button onClick={handleAddOrUpdatePlate} style={buttonStyle}>Kaydet</button>
      <button onClick={handleExportPlatesToExcel} style={{ ...buttonStyle, backgroundColor: "#22c55e" }}>📤 Plakaları Excel'e Aktar</button>
      <button onClick={handleTamamlaEksikAlanlar} style={{ ...buttonStyle, backgroundColor: "#eab308" }}>🛠 Eksik Alanları Tamamla</button>

      {authEmail === "c.caliskan@inosel.com.tr" && (
        <div style={{ marginTop: 40 }}>
          <h2>Tüm Giriş Kayıtlarını Sil</h2>
          <button onClick={handleDeleteAllLogins} style={{ ...buttonStyle, backgroundColor: "#dc2626" }}>Tüm Logları Temizle</button>

          <h2 style={{ marginTop: 40 }}>Eksiklik Tarihi Toplu Güncelle</h2>
          <input type="date" value={searchDate} onChange={(e) => setSearchDate(e.target.value)} style={inputStyle} />
          <button onClick={handleFindIssuesByDate} style={buttonStyle}>Eksiklikleri Listele</button>

          {issues.length > 0 && (
            <>
              <button onClick={() => setSelectedIds(selectedIds.length ? [] : issues.map(i => i.id))} style={{ ...buttonStyle, backgroundColor: "#6b7280" }}>
                {selectedIds.length ? "Seçimi Kaldır" : "Tümünü Seç"}
              </button>
              <ul>
                {issues.map((issue) => (
                  <li key={issue.id}>
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(issue.id)}
                      onChange={() => {
                        setSelectedIds((prev) =>
                          prev.includes(issue.id)
                            ? prev.filter((id) => id !== issue.id)
                            : [...prev, issue.id]
                        );
                      }}
                    />
                    &nbsp;<b>{issue.plate}</b> | {issue.issue} | {issue.date?.toDate().toLocaleDateString("tr-TR")}
                  </li>
                ))}
              </ul>
              <input type="date" value={newDate} onChange={(e) => setNewDate(e.target.value)} style={inputStyle} />
              <button onClick={handleUpdateSelectedDates} style={{ ...buttonStyle, backgroundColor: "#059669" }}>Seçilenlerin Tarihini Güncelle</button>
            </>
          )}
        </div>
      )}

      {message && <p style={{ marginTop: 20, color: message.includes("✅") ? "green" : "red" }}>{message}</p>}
    </div>
  );
};

const inputStyle = {
  display: "block",
  margin: "10px 0",
  padding: "8px",
  width: "100%",
  maxWidth: "100%",
  fontSize: "1rem"
};

const buttonStyle = {
  padding: "10px 20px",
  marginTop: 10,
  backgroundColor: "#1e40af",
  color: "white",
  border: "none",
  borderRadius: 4,
  cursor: "pointer"
};

export default AdminPage;
